import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { ArrowLeft, MapPin, Clock, Home, User, Navigation } from 'lucide-react';
import { useMaintenance, JobStatus } from '../../context/MaintenanceContext';
const statusMap: Record<JobStatus, {
  label: string;
  cls: string;
}> = {
  da_accettare: {
    label: 'Da accettare',
    cls: 'bg-amber-50 text-amber-700 border-amber-200'
  },
  accettata: {
    label: 'Accettata',
    cls: 'bg-muted text-muted-foreground border-border'
  },
  in_corso: {
    label: '● In corso',
    cls: 'bg-coral/5 text-coral border-coral/20'
  },
  completata: {
    label: 'Completata',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
};
export function ManInterventoDettaglioPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    jobs,
    acceptJob,
    startJob,
    completeJob
  } = useMaintenance();
  const job = jobs.find(j => j.id === id);
  if (!job) {
    return <MobileLayout data-id="element-2986">
        <Link to="/man/incarichi" className="flex items-center gap-1 text-sm text-muted-foreground hover:text-navy mb-6" data-id="element-2987">
          <ArrowLeft size={16} data-id="element-2988" />
          Incarichi
        </Link>
        <div className="bg-white border border-border rounded-xl p-10 text-center" data-id="element-2989">
          <p className="text-sm font-medium text-foreground" data-id="element-2990">
            Intervento non trovato
          </p>
        </div>
      </MobileLayout>;
  }
  const st = statusMap[job.status];
  const nextAction = () => {
    if (job.status === 'da_accettare') acceptJob(job.id);else if (job.status === 'accettata') startJob(job.id);else if (job.status === 'in_corso') completeJob(job.id);
  };
  const actionLabel = job.status === 'da_accettare' ? 'Accetta intervento' : job.status === 'accettata' ? 'Avvia intervento' : job.status === 'in_corso' ? 'Segna completato' : null;
  return <MobileLayout data-id="element-2991">
      <button onClick={() => navigate('/man/incarichi')} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-navy mb-4 transition-colors" data-id="element-2992">
        <ArrowLeft size={16} data-id="element-2993" />
        Incarichi
      </button>

      <div className="flex items-start justify-between gap-3 mb-6" data-id="element-2994">
        <div data-id="element-2995">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2996">
            {job.title}
          </h1>
          <p className="text-sm text-muted-foreground mt-1" data-id="element-2997">
            {job.trade} · {job.type}
          </p>
        </div>
        <span className={`text-[11px] font-medium px-2.5 py-1 rounded-full border flex-shrink-0 ${st.cls}`} data-id="element-2998">
          {st.label}
        </span>
      </div>

      <Card className="mb-4" data-id="element-2999">
        <CardContent className="space-y-3" data-id="element-3000">
          <h3 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-3001">
            Dettagli intervento
          </h3>
          <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3002">
            <div className="flex items-center gap-2 text-foreground" data-id="element-3003">
              <Home size={14} className="text-muted-foreground" data-id="element-3004" />
              {job.property}
            </div>
            <div className="flex items-center gap-2 text-foreground" data-id="element-3005">
              <MapPin size={14} className="text-muted-foreground" data-id="element-3006" />
              {job.zone}
            </div>
            <div className="flex items-center gap-2 text-foreground" data-id="element-3007">
              <Clock size={14} className="text-muted-foreground" data-id="element-3008" />
              {job.date} · {job.time}
            </div>
            <div className="flex items-center gap-2 text-foreground" data-id="element-3009">
              <Navigation size={14} className="text-muted-foreground" data-id="element-3010" />a{' '}
              {job.distanceKm < 1 ? `${Math.round(job.distanceKm * 1000)} m` : `${job.distanceKm} km`}
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="mb-4" data-id="element-3011">
        <CardContent className="space-y-3" data-id="element-3012">
          <h3 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-3013">
            Host
          </h3>
          <div className="flex items-center gap-2 text-sm text-foreground" data-id="element-3014">
            <User size={14} className="text-muted-foreground" data-id="element-3015" />
            {job.hostName}
          </div>
        </CardContent>
      </Card>

      <Card className="mb-6" data-id="element-3016">
        <CardContent className="flex items-center justify-between" data-id="element-3017">
          <span className="text-sm text-muted-foreground" data-id="element-3018">Compenso</span>
          <span className="text-lg font-bold text-foreground" data-id="element-3019">
            €{job.earning}
          </span>
        </CardContent>
      </Card>

      {actionLabel && <Button className="w-full" onClick={nextAction} data-id="element-3020">
          {actionLabel}
        </Button>}
    </MobileLayout>;
}